import { render, staticRenderFns } from "./SignUps.vue?vue&type=template&id=7fb2950e&scoped=true&lang=pug"
import script from "./SignUps.vue?vue&type=script&lang=js"
export * from "./SignUps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2950e",
  null
  
)

export default component.exports